import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MarketingApiService } from 'src/app/services/api/marketing-api.service';
import { OrderApiService } from 'src/app/services/api/order-api.service';
import { ProductApiService } from 'src/app/services/api/product-api.service';
import { MessageService } from 'src/app/services/message.service';
import { UserService } from 'src/app/services/user.service';
import { OrderConfirmDialogComponent } from '../../order-confirm-dialog/order-confirm-dialog.component';

@Component({
  selector: 'app-platform-dialog',
  templateUrl: './platform-dialog.component.html',
  styleUrls: ['./platform-dialog.component.scss'],
})
export class PlatformDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<PlatformDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private productApi: ProductApiService,
    private orderApi: OrderApiService,
    private message: MessageService,
    private user: UserService,
    private router: Router,
    private dialog: MatDialog
  ) {}
  selected: any = null;
  busTypes: any[] = [];
  self: any = null;
  ngOnInit(): void {
    this.findBusTypes();
    this.getSelf();
  }

  async getSelf() {
    try {
      this.self = await this.user.getSelf();
    } catch (error) {}
  }

  loading = false;
  async findBusTypes() {
    try {
      this.loading = true;
      const r = await this.productApi.findBusTypesByPlatform(this.data.id);
      this.busTypes = r.data || [];
      this.updateBusTypeList();
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  busTypeList: any[] = [];
  busTypeGroups: any[] = [];
  grouped = false;
  exclusive = false;
  updateBusTypeList() {
    this.grouped = false;
    this.busTypeList = [];
    this.selected = null;
    for (const btype of this.busTypes) {
      let inserted = false;
      for (let i = 0; i < this.busTypeList.length; i++) {
        if (Array.isArray(this.busTypeList[i])) {
          if (this.busTypeList[i][0].name === btype.name) {
            this.busTypeList[i].push(btype);
            inserted = true;
            break;
          }
        } else if (this.busTypeList[i].name === btype.name) {
          this.busTypeList[i] = [this.busTypeList[i], btype];
          inserted = true;
          this.grouped = true;
          break;
        }
      }
      if (!inserted) {
        this.busTypeList.push(btype);
      }
    }
    if (this.busTypeList.length > 0) {
      const first = this.busTypeList[0];
      if (Array.isArray(first)) {
        this.selected = first[0];
        this.busTypeGroups = first;
      } else {
        this.selected = first;
        this.busTypeGroups = [first];
      }
    }
  }

  selectName(n: any) {
    if (Array.isArray(n)) {
      this.selected = n[0];
      this.busTypeGroups = n;
    } else {
      this.selected = n;
      this.busTypeGroups = [n];
    }
    if (!this.selected.allow_exclusive && this.exclusive) {
      this.exclusive = false;
    }
  }

  selectGroup(g: any) {
    this.selected = g;
    if (!this.selected.allow_exclusive && this.exclusive) {
      this.exclusive = false;
    }
  }

  purchase() {
    if (!this.self) {
      this.router.navigateByUrl('/login');
      return;
    }
    if (!this.selected) {
      return;
    }
    this.dialog.open(OrderConfirmDialogComponent, {
      autoFocus: false,
      panelClass: 'app-dialog',
      data: {
        platform: this.data,
        bus_type: this.selected,
        exclusive: this.exclusive,
        bus_seat_id: 0,
        pre_sale_tip: this.data.pre_sale_tip,
        after_sale_tip: this.data.after_sale_tip,
        popcornStatus:
          this.data.popcornStatus &&
          (this.data.name === '爆米花' ||
            this.selected?.group === '爆米花电脑客户端'),
      },
    });
  }
}
